module.exports = __webpack_public_path__ + "static/scale-model-of-lyon-street-steps-in-san-francisco-california-47f73c5b29d034cbf782305ff908143f.png";